import type { RouteRecordRaw } from 'vue-router';

export const analyticsRoutes: RouteRecordRaw[] = [
  {
    path: 'analytics',
    name: 'analytics',
    component: () => import('./pages/AnalyticsPage.vue'),
    meta: { title: 'Analytics', requiresAuth: true, permission: 'is-admin' },
  },
];
